import { strengths } from "../../data";

export default function Marquee() {
  const items = [...strengths, ...strengths];
  return (
    <section
      data-testid="marquee-section"
      className="py-10 border-y border-[#123D5B]/8 bg-[#FBEFF3] overflow-hidden"
    >
      <div className="marquee-track flex whitespace-nowrap animate-marquee">
        {items.map((s, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-[#C24E77] px-8">
              {s}
            </span>
            <span className="text-[#C24E77]/50 text-xl" aria-hidden="true">
              ✦
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
